import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { ValueProp } from "./components/ValueProp";
import { Portfolio } from "./components/Portfolio";
import { Testimonials } from "./components/Testimonials";
import { Footer } from "./components/Footer";
import { ConsultationDialog } from "./components/ConsultationDialog";
import { CustomCursor } from "./components/CustomCursor";
import { ProjectsList } from "./components/ProjectsList";
import { TechStack } from "./components/TechStack";
import { CTABanner } from "./components/CTABanner";
import { EngineeringMindset } from "./components/EngineeringMindset";

const Landing = () => {
  const [open, setOpen] = useState(false);
  const openConsult = () => setOpen(true);

  return (
    <div className="App relative min-h-screen text-white" data-testid="landing-root">
      <CustomCursor />
      <Navbar onConsult={openConsult} />
      <main>
        <Hero onConsult={openConsult} />
        <Services onConsult={openConsult} />
        <TechStack />
        <EngineeringMindset />
        <ValueProp />
        <Portfolio onConsult={openConsult} />
        <ProjectsList />
        <Testimonials />
        <CTABanner />
      </main>
      <Footer onConsult={openConsult} />
      <ConsultationDialog open={open} onOpenChange={setOpen} />
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0A0510",
            border: "1px solid rgba(176,38,255,0.3)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
